import FutureOptionBanner from './FutureOptionBanner';
import FutureOptionSection from './FutureOptionSection';

function FutureOption() {
  return (
    <div>
      <FutureOptionBanner />
      <FutureOptionSection />
    </div>
  );
}

export default FutureOption;